export enum ConfigManagerProperties {
  apiUrl = 'apiUrl',
  appMetadataEndpoint = 'appMetadataEndpoint',
  appName = 'appName',
  bolApiEndpoint = 'bolApiEndpoint',
  buildVersion = 'buildVersion',
  csShipmentListRegionUrl = 'csShipmentListRegionUrl',
  customerLocationApiEndpoint = 'customerLocationApiEndpoint',
  dmsCorpCode = 'dmsCorpCode',
  elasticSearchApiEndpoint = 'elasticSearchApiEndpoint',
  errorToastDuration = 'errorToastDuration',
  feedbackSubject = 'feedbackSubject',
  feedbackToAddress = 'feedbackToAddress',
  freightFlowApiEndpoint = 'freightFlowApiEndpoint',
  infrastructureApiEndpoint = 'infrastructureApiEndpoint',
  invoiceApiEndpoint = 'invoiceApiEndpoint',
  locationApiEndpoint = 'locationApiEndpoint',
  loggedInUserRoot = 'loggedInUserRoot',
  loggingApiEndpoint = 'loggingApiEndpoint',
  membershipApiEndpoint = 'membershipApiEndpoint',
  pricingApiEndpoint = 'pricingApiEndpoint',
  production = 'production',
  region = 'region',
  releaseNotesLink = 'releaseNotesLink',
  scopeOptions = 'scopeOptions',
  secretToken = 'secretToken',
  shipmentApiEndpoint = 'shipmentApiEndpoint',
  successToastDuration = 'successToastDuration',
  userContextPath = 'userContextPath',
  userpreferenceApiEndpoint = 'userpreferenceApiEndpoint',
}
